import './index.css';
import 'react-sortable-tree/style.css';
import { create } from 'jss';
import config from './globals/config'
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { StylesProvider, jssPreset } from '@material-ui/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import jssExtend from 'jss-plugin-extend';
import { FusionAuthProvider } from '@fusionauth/react-sdk';
import { PersistGate } from 'redux-persist/integration/react'

import * as serviceWorker from './serviceWorker';
import App from './App';
import configureStore, { history } from './configureStore';
const storeConfig = configureStore();
const jss = create({
    plugins: [jssExtend(), ...jssPreset().plugins],
});

console.log('Config', config)
    ReactDOM.render(
        <Provider store={storeConfig.store}>
            <PersistGate loading={null} persistor={storeConfig.persistor}>

            <ConnectedRouter history={history}>
                <StylesProvider jss={jss}>
                    <FusionAuthProvider
                        clientID={config.AUTH_CLIENT_ID}     // Your FusionAuth client ID
                        serverUrl={config.AUTH_DOMAIN}    // The base URL of your server for the token exchange
                        redirectUri={window.location.origin + '/auth/callback'}  // The URI that the user is directed to after the login/register/logout action
                        tokenRefreshPath={`/app/refresh/${config.AUTH_CLIENT_ID}`}

                    >
                        <App />
                    </FusionAuthProvider>
                </StylesProvider>
            </ConnectedRouter>
            </PersistGate>
        </Provider>,
        document.getElementById('root'),
    );


// expose store when run in Cypress
if (window.Cypress) {
    window.store = storeConfig.store;
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls. Learn
// more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
